import React from 'react';
import AssignmentIcon from '@material-ui/icons/Assignment';

import { ReportCardLink } from './parent-player-group-card.styles';

interface IReportCardAffordanceProps {
  to: string;
  playerName?: string;
}

// Desktop: small inline pill by the chevron. Mobile: full-width row (see
// ReportCardLink styles). Stops propagation so it doesn't double-navigate.
export const ReportCardAffordance: React.FC<IReportCardAffordanceProps> = ({ to, playerName }) => (
  <ReportCardLink
    to={to}
    onClick={(event) => event.stopPropagation()}
    aria-label={playerName ? `View ${playerName}'s report card` : 'View report card'}
  >
    <AssignmentIcon fontSize="small" />
    <span>Report card</span>
  </ReportCardLink>
);
